import React from "react";

export function NoData({
	placeholder = "No data available.",
}: {
	placeholder: string;
}) {
	return (
		<div className="no-search-results">
			<p>{placeholder}</p>
		</div>
	);
}
